module.exports = require("./jgo.d.ts");